import { SchemaValidationItemError } from "./SchemaValidationItemError"

/**
 * Wrapper error for iterable list of SchemaValidationItemError items
 */
export class SchemaValidationError extends Error {
    /**
     * @param itemArray SchemaValidationItemError array
     */
    constructor(
        public readonly itemArray: SchemaValidationItemError[],
        public readonly totalRows: number,
        public readonly trimmed: boolean
    ) {
        super("Invalid Data")
        this.name = "SchemaValidationError"
    }
}
